import { Briefcase } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "projects",
  icon: Briefcase,
  tabs: [
    { to: "/projects", label: "nav.projects", perm: ["projects.project.read"] },
    { to: "/tasks", label: "nav.myTasks", perm: ["projects.task.read"] },
    { to: "/timesheet", label: "nav.timesheet", perm: ["projects.time.create"] },
    { to: "/approvals", label: "nav.approvals", perm: ["projects.time.approve", "projects.project.update"] },
  ],
  create: [{ label: "create.project", to: "/projects?new=1", perm: "projects.project.create" }],
  setup: { first_project: "/projects?new=1" },
};
